module.exports = __webpack_public_path__ + "img/country_caramel_ba_list.da88681c.jpg";